import { Injectable, inject } from '@angular/core'
import { NavigationError, Router } from '@angular/router'
import { BehaviorSubject, Observable } from 'rxjs'
import { filter } from 'rxjs/operators'
import { isChunkLoadError } from 'src/app/domain/utils/functions/is-chunk-load-error'
import { BrowserService } from 'src/app/infra/browser/browser.service'

@Injectable({ providedIn: 'root' })
export class AppVersionUpdateService {
  private router: Router = inject(Router)
  private browserService: BrowserService = inject(BrowserService)

  private isShowSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  private alreadyShown: boolean = false
  private isStarted: boolean = false

  public isShow$: Observable<boolean> = this.isShowSubject.asObservable()

  public start(): void {
    if (this.isStarted) return
    this.isStarted = true
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection)
    this.router.events.pipe(filter((event): event is NavigationError => event instanceof NavigationError)).subscribe((event) => this.showIfChunkLoadError(event.error))
  }

  public showIfChunkLoadError(error: unknown): void {
    if (!isChunkLoadError(error) || this.alreadyShown) return
    this.alreadyShown = true
    this.isShowSubject.next(true)
  }

  public reload(): void {
    this.browserService.reloadPage()
  }

  private handleUnhandledRejection = (event: PromiseRejectionEvent): void => {
    this.showIfChunkLoadError(event.reason)
  }
}
